import { render, staticRenderFns } from "./IgnoreList.vue?vue&type=template&id=4cba7548&"
import script from "./IgnoreList.vue?vue&type=script&lang=js&"
export * from "./IgnoreList.vue?vue&type=script&lang=js&"
import style0 from "./IgnoreList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports